export default __webpack_public_path__ + "static/media/LLP-2.6773bd84.png";